import { Component, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Gallery from "@/components/Gallery";
import Process from "@/components/Process";
import About from "@/components/About";
import Pricing from "@/components/Pricing";
import GiftIdeas from "@/components/GiftIdeas";
import Testimonials from "@/components/Testimonials";
import ClientPhotos from "@/components/ClientPhotos";
import OrderForm from "@/components/OrderForm";
import Footer from "@/components/Footer";
import PrivacyPage from "@/pages/PrivacyPage";
import { Toaster } from "@/components/ui/sonner";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#08070d] text-center text-white">
          <div>
            <p className="font-display text-2xl font-bold">Oups, un pinceau a dérapé.</p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="btn-holo mt-5 rounded-full px-6 py-3 text-sm font-bold text-[#08070d]"
            >
              Recharger la page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/confidentialite" element={<PrivacyPage />} />
          <Route path="*" element={<AppShell />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

function AppShell() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    const path = window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");

    if (path === "/payment/success" && sessionId) {
      const check = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/payments/status/${sessionId}`
          );
          if (res.data.payment_status === "paid") {
            toast.success("Paiement réussi ! Merci — envoyez-moi maintenant les détails de votre création.");
          } else {
            toast.info("Paiement en cours de confirmation — vous recevrez la confirmation très vite.");
          }
        } catch {
          toast.info("Paiement en cours de confirmation — vous recevrez la confirmation très vite.");
        }
        window.history.replaceState({}, "", "/");
      };
      check();
    } else if (path === "/payment/cancel") {
      toast.info("Paiement annulé — vous pouvez réessayer quand vous voulez.");
      window.history.replaceState({}, "", "/");
    }
  }, []);

  return (
    <div className="relative min-h-screen overflow-x-clip bg-[#08070d] text-[#f4f3f8] antialiased">
      <div className="bg-grain pointer-events-none fixed inset-0 z-[60] opacity-[0.05]" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Gallery />
        <Process />
        <About />
        <Pricing />
        <GiftIdeas />
        <Testimonials />
        <ClientPhotos />
        <OrderForm />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}
